// extracted by mini-css-extract-plugin
export var lastFour = "UpgradeForm_lastFour__zr4FI";
export var ufCard = "UpgradeForm_ufCard__lnUt4";
export var ufContainer = "UpgradeForm_ufContainer__tzMGr";
export var ufTitle = "UpgradeForm_ufTitle__Wj0oI";